import { TeamView, TeamColumn } from "@common/types/views/teamViews";
import { ViewType } from "@common/types/views/views";

export function createDefaultTeamView(): TeamView {
    return {
        type: ViewType.TEAM,
        columns: [
            { id: TeamColumn.USER },
            { id: TeamColumn.CLIENTS },
            { id: TeamColumn.ROLE },
            { id: TeamColumn.LAST_ACTIVE },
            { id: TeamColumn.ACTIONS, options: { pin: "right" } },
        ],
        filters: {},
    };
}
